import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _523c031c = () => interopDefault(import('../pages/admin/index.vue' /* webpackChunkName: "pages/admin/index" */))
const _bdc9d500 = () => interopDefault(import('../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _33842c0c = () => interopDefault(import('../pages/events-and-activities/index.vue' /* webpackChunkName: "pages/events-and-activities/index" */))
const _da826aa8 = () => interopDefault(import('../pages/explore-space.vue' /* webpackChunkName: "pages/explore-space" */))
const _093eee5e = () => interopDefault(import('../pages/facilities.vue' /* webpackChunkName: "pages/facilities" */))
const _6bdd61a5 = () => interopDefault(import('../pages/landing-menu.vue' /* webpackChunkName: "pages/landing-menu" */))
const _57062649 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _5260a94c = () => interopDefault(import('../pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _7411a9bb = () => interopDefault(import('../pages/mitr-download.vue' /* webpackChunkName: "pages/mitr-download" */))
const _78204ca7 = () => interopDefault(import('../pages/mitrapp.vue' /* webpackChunkName: "pages/mitrapp" */))
const _f09dcd50 = () => interopDefault(import('../pages/my-profile.vue' /* webpackChunkName: "pages/my-profile" */))
const _04a9844a = () => interopDefault(import('../pages/my-profile/index.vue' /* webpackChunkName: "pages/my-profile/index" */))
const _42d8e9a2 = () => interopDefault(import('../pages/my-profile/booking.vue' /* webpackChunkName: "pages/my-profile/booking" */))
const _16943e11 = () => interopDefault(import('../pages/my-profile/edit.vue' /* webpackChunkName: "pages/my-profile/edit" */))
const _68d1eabc = () => interopDefault(import('../pages/my-profile/password.vue' /* webpackChunkName: "pages/my-profile/password" */))
const _0f71be30 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _5a1b3c1a = () => interopDefault(import('../pages/register.vue' /* webpackChunkName: "pages/register" */))
const _daca14f2 = () => interopDefault(import('../pages/registration-completed.vue' /* webpackChunkName: "pages/registration-completed" */))
const _369df0ae = () => interopDefault(import('../pages/reset-password.vue' /* webpackChunkName: "pages/reset-password" */))
const _3be65a72 = () => interopDefault(import('../pages/room-result/index.vue' /* webpackChunkName: "pages/room-result/index" */))
const _673fd6db = () => interopDefault(import('../pages/rooms/index.vue' /* webpackChunkName: "pages/rooms/index" */))
const _5e4daa42 = () => interopDefault(import('../pages/search-result.vue' /* webpackChunkName: "pages/search-result" */))
const _9d399d80 = () => interopDefault(import('../pages/spaces/index.vue' /* webpackChunkName: "pages/spaces/index" */))
const _a2a85568 = () => interopDefault(import('../pages/style-check.vue' /* webpackChunkName: "pages/style-check" */))
const _375c4167 = () => interopDefault(import('../pages/terms.vue' /* webpackChunkName: "pages/terms" */))
const _5a6f4530 = () => interopDefault(import('../pages/users.vue' /* webpackChunkName: "pages/users" */))
const _5cb9942a = () => interopDefault(import('../pages/users/index.vue' /* webpackChunkName: "pages/users/index" */))
const _096e99a0 = () => interopDefault(import('../pages/users/verify.vue' /* webpackChunkName: "pages/users/verify" */))
const _9211e26e = () => interopDefault(import('../pages/verify.vue' /* webpackChunkName: "pages/verify" */))
const _a3029978 = () => interopDefault(import('../pages/view-booking/index.vue' /* webpackChunkName: "pages/view-booking/index" */))
const _05a6d1dd = () => interopDefault(import('../pages/admin/access-report.vue' /* webpackChunkName: "pages/admin/access-report" */))
const _beecbcee = () => interopDefault(import('../pages/admin/login.vue' /* webpackChunkName: "pages/admin/login" */))
const _cc162c82 = () => interopDefault(import('../pages/admin/verify-user.vue' /* webpackChunkName: "pages/admin/verify-user" */))
const _025222e2 = () => interopDefault(import('../pages/events-and-activities/_id.vue' /* webpackChunkName: "pages/events-and-activities/_id" */))
const _4dcc515a = () => interopDefault(import('../pages/room-result/_id.vue' /* webpackChunkName: "pages/room-result/_id" */))
const _06fbd403 = () => interopDefault(import('../pages/rooms/_id.vue' /* webpackChunkName: "pages/rooms/_id" */))
const _1ae6f8b0 = () => interopDefault(import('../pages/spaces/_id.vue' /* webpackChunkName: "pages/spaces/_id" */))
const _55e8b6ac = () => interopDefault(import('../pages/view-booking/_id.vue' /* webpackChunkName: "pages/view-booking/_id" */))
const _e542f99c = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
      path: "/admin",
      component: _523c031c,
      name: "admin"
    }, {
      path: "/contact",
      component: _bdc9d500,
      name: "contact"
    }, {
      path: "/events-and-activities",
      component: _33842c0c,
      name: "events-and-activities"
    }, {
      path: "/explore-space",
      component: _da826aa8,
      name: "explore-space"
    }, {
      path: "/facilities",
      component: _093eee5e,
      name: "facilities"
    }, {
      path: "/landing-menu",
      component: _6bdd61a5,
      name: "landing-menu"
    }, {
      path: "/login",
      component: _57062649,
      name: "login"
    }, {
      path: "/logout",
      component: _5260a94c,
      name: "logout"
    }, {
      path: "/mitr-download",
      component: _7411a9bb,
      name: "mitr-download"
    }, {
      path: "/mitrapp",
      component: _78204ca7,
      name: "mitrapp"
    }, {
      path: "/my-profile",
      component: _f09dcd50,
      children: [{
        path: "",
        component: _04a9844a,
        name: "my-profile"
      }, {
        path: "booking",
        component: _42d8e9a2,
        name: "my-profile-booking"
      }, {
        path: "edit",
        component: _16943e11,
        name: "my-profile-edit"
      }, {
        path: "password",
        component: _68d1eabc,
        name: "my-profile-password"
      }]
    }, {
      path: "/privacy",
      component: _0f71be30,
      name: "privacy"
    }, {
      path: "/register",
      component: _5a1b3c1a,
      name: "register"
    }, {
      path: "/registration-completed",
      component: _daca14f2,
      name: "registration-completed"
    }, {
      path: "/reset-password",
      component: _369df0ae,
      name: "reset-password"
    }, {
      path: "/room-result",
      component: _3be65a72,
      name: "room-result"
    }, {
      path: "/rooms",
      component: _673fd6db,
      name: "rooms"
    }, {
      path: "/search-result",
      component: _5e4daa42,
      name: "search-result"
    }, {
      path: "/spaces",
      component: _9d399d80,
      name: "spaces"
    }, {
      path: "/style-check",
      component: _a2a85568,
      name: "style-check"
    }, {
      path: "/terms",
      component: _375c4167,
      name: "terms"
    }, {
      path: "/users",
      component: _5a6f4530,
      children: [{
        path: "",
        component: _5cb9942a,
        name: "users"
      }, {
        path: "verify",
        component: _096e99a0,
        name: "users-verify"
      }]
    }, {
      path: "/verify",
      component: _9211e26e,
      name: "verify"
    }, {
      path: "/view-booking",
      component: _a3029978,
      name: "view-booking"
    }, {
      path: "/admin/access-report",
      component: _05a6d1dd,
      name: "admin-access-report"
    }, {
      path: "/admin/login",
      component: _beecbcee,
      name: "admin-login"
    }, {
      path: "/admin/verify-user",
      component: _cc162c82,
      name: "admin-verify-user"
    }, {
      path: "/events-and-activities/:id?",
      component: _025222e2,
      name: "events-and-activities-id"
    }, {
      path: "/room-result/:id?",
      component: _4dcc515a,
      name: "room-result-id"
    }, {
      path: "/rooms/:id",
      component: _06fbd403,
      name: "rooms-id"
    }, {
      path: "/spaces/:id",
      component: _1ae6f8b0,
      name: "spaces-id"
    }, {
      path: "/view-booking/:id?",
      component: _55e8b6ac,
      name: "view-booking-id"
    }, {
      path: "/",
      component: _e542f99c,
      name: "index"
    }],

  fallback: false
}

export function createRouter() {
  return new Router(routerOptions)
}
